import script from "./TopNavBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./TopNavBar.vue?vue&type=script&lang=ts&setup=true"

import "./TopNavBar.vue?vue&type=style&index=0&id=2ffc092c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ffc092c"]])

export default __exports__